import { type TrinityAppNames } from '@trinity/utils'
import { setTheme } from '../../theme'
import { CssBaseline, ThemeProvider, useGlobalState, useHasUpdate } from '../../hooks'
import { DateAdapter, LocalizationProvider } from '../Dates'
import { GlobalProvider } from './GlobalProvider'
import { Button } from '../Buttons'
import { Refresh } from '../Icons'
import { useEffect } from 'react'

interface TrinityWrapperProps {
  appName: TrinityAppNames
  user: TrinityAPI.LoginType
  children: React.ReactNode
}

export function TrinityWrapper({ appName, user, children }: TrinityWrapperProps) {
  const theme = setTheme(appName)

  return (
    <ThemeProvider theme={theme}>
      <GlobalProvider user={user}>
        <LocalizationProvider dateAdapter={DateAdapter}>
          <CssBaseline />
          {children}
        </LocalizationProvider>
      </GlobalProvider>
    </ThemeProvider>
  )
}

export function BaseTrinityWrapper({ appName, children }: Omit<TrinityWrapperProps, 'user'>) {
  const theme = setTheme(appName)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export function TrinityUpdate() {
  const { setToastInfo } = useGlobalState()
  const { hasUpdate } = useHasUpdate()

  useEffect(() => {
    if (hasUpdate) {
      setToastInfo(() => ({
        show: true,
        message: 'A new version is available',
        severity: 'success',
        child: (
          <Button onClick={() => location.reload()} startIcon={<Refresh />} variant='outlined' color='success'>
            Refresh now
          </Button>
        ),
        autoHideDuration: null,
      }))
    }
  }, [hasUpdate, setToastInfo])

  return null
}
